import React from 'react';

class CompanyBio extends React.Component {
 
  render() {
    return (
      <div className="col l6 s12">
          <h5 className="white-text">My Bio</h5>
          <p className="grey-text text-lighten-4">
          	I like to think more of myself as a sanguine. Working on making myself better day by day. I love working 
          	on Algorithms, Enterprise Appliations and teaching. Praying to Almighty ALLAH to help me in my everyday activities.
          .</p>


        </div>
        );
  }

}

export default CompanyBio;



/** WEBPACK FOOTER **
 ** ./src/client/app/CompanyBio.jsx
 **/